import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTabChangeEvent } from '@angular/material';
import { PatientBannerService } from '../patient-banner/patient-banner.service';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';

@Component({
  selector: 'app-order-note',
  templateUrl: './order-note.component.html',
  styleUrls: ['./order-note.component.css']
})
export class OrderNoteComponent implements OnInit {

  orderId: any;
  orderactivetab = 0;
  // @Input() orderactivetab = 1;
  @Output() tabClicked = new EventEmitter<string>();
  constructor(private route: ActivatedRoute, private bannerService: PatientBannerService, private crypto: AESAlgorithm
    , private router: Router) {
    this.getSystem();
  }

  getSystem() {

    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    localStorage.setItem("ordernoteheaderVisibility", "True");
    sessionStorage.removeItem("rxfromsearch");
    CommonComponents.ordernoteheaderVisibility = true;
    CommonComponents.headerVisibility = false;
  }

  ngOnInit() {
    CommonComponents.headerVisibility = false;
    this.route.queryParams.subscribe(params => {
      this.orderId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['id']));
    });
    //alert(this.orderId)

    this.bannerService.toggle(CommonComponents.patientId);
    this.router.navigateByUrl('/Dx');

  }

  onLinkClick(event: MatTabChangeEvent) {

    event.tab.isActive = true;
    this.tabClicked.emit(event.tab.textLabel);
    //this.router.navigateByUrl('/OrderNote/'+event.tab.textLabel.replace(" ", "")); 
    //  this.router.navigateByUrl('/'+event.tab.textLabel.replace(" ","")); 
    //  this.tabClicked.emit();


  }
  tabChanged(event) {

  }

}
